export const WORK_FLOW_TYPE = {
   GLOBAL_CASE: "globalCase",
   GLOBAL_CHECKS: "globalCheck",
   CASE: "CASE",
   CHECKS: "CHECKS"
}